import * as types from '../actiontypes';

export function createProject(url, payload) {
	return {
		type: types.CREATE_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		payload: payload
	};
}

export function draftProject(url, payload) {
	normalizeRequestPayload(payload);
	return {
		type: types.DRAFT_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: payload
			}
		}
	};
}

export function finishProject(url, payload, isRollForwardMode) {
	if (!isRollForwardMode) {
		// we need to send manual contacts for rollforward
		normalizeRequestPayload(payload.savedProject);
	}

	return {
		type: types.FINISH_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: payload
			}
		}
	};
}

export function normalizeRequestPayload(payload) {
	// This is being done to fix one issue where request size was large and api gateway was giving error for large side
	payload?.orgStructure.forEach((item) => {
		item.contacts = [];
	});
}

export function cancelProject(url, data) {
	return {
		type: types.CANCEL_PROJECT,
		// meta: {
		// 	api: {
		// 		url: url,
		// 		method: 'CREATE'
		// 	}
		// }
		payload: data
	};
}

export function clearProject() {
	return {
		type: types.CLEAR_PROJECT
	};
}

export function updateProject(url, payload, isRollForwardMode) {
	if (!isRollForwardMode) {
		// we need to send manual contacts for rollforward
		normalizeRequestPayload(payload.savedProject);
	}

	return {
		type: types.UPDATE_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: payload.savedProject
			}
		},
		stepUpdated: payload.stepUpdated
	};
}

export function createRollForwardProject(url, payload) {
	return {
		type: types.CREATE_ROLL_FORWARD_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload
			}
		},
		payload: payload
	};
}
